import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavigation = (sectionId) => {
    // If we're not on the home page, navigate to home first
    if (location.pathname !== '/') {
      navigate('/', { replace: true });
      // Wait for navigation to complete, then scroll
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      // If we're on home page, just scroll to section
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
    setIsMobileMenuOpen(false);
  };

  const handleLogoClick = () => {
    navigate('/');
  };

  return (
    <header className={`header-nav ${isScrolled ? 'scrolled' : ''}`}>
      <div className="container">
        <div className="flex items-center justify-between py-4">
          {/* Logo - Now clickable */}
          <div className="flex items-center gap-3 cursor-pointer" onClick={handleLogoClick}>
            <img 
              src="/nsa-logo.png" 
              alt="NSA Financial Services" 
              className="logo-main"
            />
            <div>
              <h1 className="font-poppins text-xl font-semibold text-primary-green">
                NSA Financial Services
              </h1>
              <p className="text-sm text-secondary opacity-75">
                Guiding Your Wealth
              </p>
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            <button onClick={() => handleNavigation('home')} className="nav-link">
              Home
            </button>
            <button onClick={() => handleNavigation('about')} className="nav-link">
              About
            </button>
            <button onClick={() => handleNavigation('services')} className="nav-link">
              Services
            </button>
            <button onClick={() => handleNavigation('contact')} className="nav-link">
              Contact
            </button>
          </nav>

          {/* Mobile Menu Button */}
          <button 
            className="md:hidden p-2"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <nav className="md:hidden py-4 border-t border-gray-200">
            <div className="flex flex-col gap-4">
              <button 
                onClick={() => handleNavigation('home')} 
                className="nav-link text-left"
              >
                Home
              </button>
              <button 
                onClick={() => handleNavigation('about')} 
                className="nav-link text-left"
              >
                About
              </button>
              <button 
                onClick={() => handleNavigation('services')} 
                className="nav-link text-left"
              >
                Services
              </button>
              <button 
                onClick={() => handleNavigation('contact')} 
                className="nav-link text-left"
              >
                Contact
              </button>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;